diy.angular.registerFactory('diyfmselectiondata', ['diyfmconfig', function(diyfmconfig) {

    /**
     * This number is increased any time anything related to a
     * selection/insertion happens.
     * This is watched over so we can easily update the selection
     * in the UI only if the selection object has changed
     * @type {number}
     */
    var selectionStateNumber = 0;

    /*
     * We use the an items array to keep the items,
     * and on the same position on the itemsHash we find the item's hash
     * The reason for this is that checking the reference is not enough
     * since we are interested in finding an image by it's hash
     * (id + other properties).
     * Searching will be done on the selectedItemsHash, but the item used
     * will be from the selectedItems array. This is more an optimization,
     * since native methods like indexOf on arrays are faster than
     * interating and comparing, especially in a digest cycle
     */
    var insertedItems = [],
        insertedItemsHash = [],
        selectedItems = [],
        selectedItemsHash = [];

    /**
     * Add an item to the selection/insertion
     * @param item
     * @param types example ['select', 'insert']
     * @param index (optional) at what index to add, default add to the end
     */
    var addItem = function(item, types, index) {
        if (!Array.isArray(types)) {
            throw new Error();
        }

        /* get item hash so we can search it through the hash arrays */
        var itemHash = item.getHash(), selIndex, insIndex;

        /* add the item to the selection array */
        if (types.indexOf('select') > -1) {
            selIndex = index === undefined ? selectedItems.length : index;
            if (item.canSelect() && selectedItemsHash.indexOf(itemHash) === -1) {
                selectedItemsHash.splice(selIndex, 0, itemHash);
                selectedItems.splice(selIndex, 0, item);
            }
        }

        /* add the item to the insertion array */
        if (!diyfmconfig.isInManagementMode() && types.indexOf('insert') > -1) {
            if (item.canSelect() && insertedItemsHash.indexOf(itemHash) === -1) {

                var source = item.getSource();
                if (
                    typeof source.canAddToInsert !== 'function'
                    || (source.canAddToInsert && source.canAddToInsert(item))
                ) {
                    /* if maximum one element can be inserted, just replace it */
                    if (diyfmconfig.getMaxSelection() === 1) {
                        insertedItemsHash.shift();
                        insertedItems.shift();
                        insIndex = 0;
                    } else {
                        insIndex = index === undefined ? insertedItems.length : index;
                    }

                    insertedItemsHash.splice(insIndex, 0, itemHash);
                    insertedItems.splice(insIndex, 0, item);
                }
            }
        }

        selectionStateNumber++;
    };

    var setSelectionItems = function(items) {
        selectedItemsHash = [];
        selectedItems = [];
        items.forEach(function(item){
            selectedItemsHash.push(item.getHash());
            selectedItems.push(item);
        });

        selectionStateNumber++;
    };

    /**
     * Remove an item from the selection/insertion
     * @param item the item (object), as an item or as an item hash (string)
     * @param types example ['select', 'insert']
     */
    var removeItem = function(item, types) {
        if (!Array.isArray(types)) {
            throw new Error();
        }

        var itemHash,
            idx;

        if ('string' === typeof item) {
            itemHash = item;
        } else {
            itemHash = item.getHash()
        }

        /* if we should remove from selection, we remove selection and insertion */
        if (types.indexOf('select') > -1) {
            idx = selectedItemsHash.indexOf(itemHash);
            if (idx > -1) {
                selectedItems.splice(idx, 1);
                selectedItemsHash.splice(idx, 1);
            }
        }

        /* if we should remove from insertion, remove it */
        if (types.indexOf('insert') > -1) {
            idx = insertedItemsHash.indexOf(itemHash);
            if (idx > -1) {
                insertedItems.splice(idx, 1);
                insertedItemsHash.splice(idx, 1);
            }
            var source = item.getSource();
            if (typeof source.itemRemovedFromInsert === 'function'){
                source.itemRemovedFromInsert(item);
            }
        }

        selectionStateNumber++;
    };

    /**
     * Remove all items from the selection/insertion
     * @param types example ['select', 'insert']
     */
    var removeAllItems = function(types) {
        if (!Array.isArray(types)) {
            throw new Error();
        }

        /* if we should remove from selection, we remove selection and insertion */
        if (types.indexOf('select') > -1) {
            selectedItems.length = 0;
            selectedItemsHash.length = 0;
        }

        /* if we should remove from insertion, remove it */
        if (types.indexOf('insert') > -1) {
            for (var i = 0; i < insertedItems.length; i++) {
                var item = insertedItems[i];
                var source = item.getSource();
                if (typeof source.itemRemovedFromInsert === 'function') {
                    source.itemRemovedFromInsert(item);
                }
            }
            insertedItems.length = 0;
            insertedItemsHash.length = 0;
        }

        selectionStateNumber++;
    };

    var getSelectionStateNumber = function() {
        return selectionStateNumber;
    };

    /**
     * Get item selection type
     * @param item
     * @returns {Array} example ['select', 'insert']
     */
    var getItemSelectionType = function(item) {
        var types = [];

        var itemHash = item.getHash();

        if (selectedItemsHash.indexOf(itemHash) > -1) {
            types.push('select');
        }

        if (insertedItemsHash.indexOf(itemHash) > -1) {
            types.push('insert');
        }

        return types;
    };

    var isItemSelected = function(item) {
        var selectionType = getItemSelectionType(item);
        return selectionType.indexOf('select') > -1;
    };

    var isItemInserted = function(item) {
        var selectionType = getItemSelectionType(item);
        return selectionType.indexOf('insert') > -1;
    };

    var getInsertedItems = function() {
        return insertedItems;
    };

    var getSelectedItems = function() {
        return selectedItems;
    };

    var allowInsertions = function() {
        return !diyfmconfig.isInManagementMode();
    }

    /* make these methods public */
    return {
        addItem: addItem,
        removeItem: removeItem,
        removeAllItems: removeAllItems,
        getItemSelectionType: getItemSelectionType,
        isItemSelected: isItemSelected,
        isItemInserted: isItemInserted,
        getSelectionStateNumber: getSelectionStateNumber,
        getInsertedItems: getInsertedItems,
        getSelectedItems: getSelectedItems,
        allowInsertions: allowInsertions,
        setSelectionItems: setSelectionItems
    };
}]);









/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/services/diyfmselectiondata.js
 ** module id = 940
 ** module chunks = 0
 **/